import React, { ReactElement, useEffect } from 'react';
import { Button, LoaderButton } from 'idsk-react-components';
import './bodComponent.scss';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { useClient, useClientStatusContext } from '../../../../../context/ClientStatusContext';
import { getLatestDocumentFormData }
  from '../../../../../client/external/evidencnaaplikacia/documentFormDataDetailClient';
import Uuid from '../../../../../model/Uuid';
import { NavrhUzneseniaVladyFormData }
  from '../../../../../model/sprievodnyDokument/navrhUzneseniaVlady/NavrhUzneseniaVladyFormData';
import { useSuccessMessageContext } from '../../../../../context/SuccessMessageContext';
import { mapNavrhUzneseniaVladyFormData }
  from '../../../../../page/SprievodnyDokument/NavrhUzneseniaVladyEditPage/hook/useNavrhUzneseniaVladyFormData';

export interface Props {
  setInitFormData: (formData: NavrhUzneseniaVladyFormData) => void;
  stadiumUuid?: Uuid,
  legMaterialUuid: Uuid;
}

const LoadNavrhUzneseniaDataButton = ({
  setInitFormData, stadiumUuid, legMaterialUuid,
}: Props): ReactElement => {
  const { displaySuccess } = useSuccessMessageContext();
  const { handleStatus } = useClientStatusContext();
  const {
    wrapClient: loadClient,
    status: loadClientStatus,
  } = useClient(getLatestDocumentFormData);

  const loadNavrhUzneseniaData = async (): Promise<void> => {
    const { data } = await loadClient(legMaterialUuid, 'NavrhUzneseniaVladySlovenskejRepubliky', stadiumUuid);
    if (data && data.formData) {
      setInitFormData(mapNavrhUzneseniaVladyFormData(data.formData, true));
    }
    displaySuccess('Údaje boli úspešne získané z dokumentu typu "Návrh uznesenia vlády Slovenskej republiky", '
      + `ktorý bol vytvorený cez formulár a nachádza sa v štádiu ${data?.stadium?.nazov} tohto procesu.`);
  };

  useEffect(() => {
    if (loadClientStatus?.responseCode === 404) {
      handleStatus({
        loading: false,
        finished: true,
        responseCode: 404,
        failed: true,
        generalErrors: [
          {
            message: 'Nie je možné načítať údaje. Dokument typu "Návrh uznesenia vlády Slovenskej republiky"'
              + ' nebol k tomuto procesu vytvorený cez formulár.',
          }],
        fieldErrors: [],
      });
    }
  }, [loadClientStatus, handleStatus]);

  return (
    <ConfirmModal
      question="Naozaj si prajete automaticky vyplniť formulár?"
      description="Po vykonaní tejto funkcionality budú prepísané všetky údaje v tomto formulári."
      cancelButtonText="Nie"
      confirmButton={
        (
          <Button
            buttonStyle="action"
            size="large"
          >
            Áno
          </Button>
        )
      }
      openButton={(
        <LoaderButton
          size="large"
          buttonStyle="third"
          loading={loadClientStatus.loading}
          disableOutsideClickWhileLoading
        >
          Vyplniť údajmi z návrhu uznesenia vlády Slovenskej republiky
        </LoaderButton>
      )}
      doAfterConfirm={loadNavrhUzneseniaData}
    />
  );
};

export default LoadNavrhUzneseniaDataButton;
